'use client';

import { FC, useContext } from 'react';
import clsx from 'clsx';
import FormCheckbox from '@/components/FormCheckbox';
import CompareFeatureContext, { CompareFeatureContextType } from '@/context/CompareFeatureContext';
import { CompareCheckboxAdapterProps } from './types';
import styles from './CompareCheckboxAdapter.module.css';

const CompareCheckboxAdapter: FC<CompareCheckboxAdapterProps> = ({
  id,
  controllerClassName,
  mainClassName,
  labelClassName,
}) => {
  const { compareData, isSelectedToCompare, handleCompare, handleRedirectCompare } = useContext(
    CompareFeatureContext,
  ) as CompareFeatureContextType;

  const isSelected = isSelectedToCompare(compareData, id);

  return (
    <FormCheckbox
      id={`compare-${id}`}
      name={`compare-${id}`}
      value={isSelected}
      label={'Compare'}
      checkboxMainContainerClasses={clsx(styles.checkboxMain, mainClassName)}
      checkboxContainerClassName={styles.checkboxContainer}
      checkboxControllerClassName={clsx(styles.checkboxController, controllerClassName)}
      checkboxLabelClassName={clsx(styles.checkboxLabel, labelClassName, {
        [styles.checkboxLabelActive]: isSelected,
      })}
      onChange={(val: React.ChangeEvent<HTMLInputElement>) => {
        handleCompare(id, val.target.checked);
      }}
      labelClick={!isSelected}
      clickOnLabel={isSelected}
      clickOnLabelCallback={handleRedirectCompare}
    />
  );
};

export default CompareCheckboxAdapter;
